import { useMemo } from "react";
import { translate } from "../../translations/index.ts";

export default function StatementsProgress({
  statements,
  answers,
  participants,
}) {
  const groupedAnswers = useMemo(
    () =>
      answers.reduce((acc, cur) => {
        acc[cur.statementId] = (acc[cur.statementId] || 0) + 1;
        return acc;
      }, {}),
    [answers],
  );

  return (
    <>
      <h1 className="voting-session__title">
        <span className="--highlighted">
          {translate("teacher.votingSession.statementsProgress.title")}
        </span>
      </h1>
      {statements.map((statement, index) => (
        <StatementProgress
          index={index + 1}
          participants={participants}
          statement={statement}
          key={statement._id}
          answersCount={groupedAnswers[statement._id]}
        />
      ))}
    </>
  );
}

function StatementProgress({ index, statement, answersCount, participants }) {
  return (
    <div className="statement-progress" data-statement-id={statement._id}>
      <h2 className="statement-progress__title">
        Q{index}: {statement.description}
      </h2>
      <progress
        className="statement-progress__bar"
        max={participants}
        value={answersCount || 0}
      ></progress>
    </div>
  );
}
